var resendInvitation = (function () {
    const init = function () {
        $('.mdi-replay').on('click',
            function () {
                const userId = $(this).data('user-id');
                var $currentLoader = $(this).siblings('.invitation-loader');
                $currentLoader.css('display', 'inline-block');
                $(this).hide();

                $.ajax({
                        url: `/UserManagement/ResendInvitation/${userId}`,
                        method: 'PUT',
                        contentType: 'application/json'
                    })
                    .done(function (data) {
                        $(this).show();
                        $currentLoader.hide();
                        $.showNotification(data.header, data.message, data.succeed);
                    });
            });
    };

    return {
        init: init
    };

})();
